//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce as debounceHelper } from 'debounce';
import { TippyComponent as Tippy } from 'vue-tippy';

import { version } from '../../package.json';

export default {
  name: 'ViuInput',
  props: {
    value: [String, Number],
    /**
     * El tipo del input, puede ser text, password o number.
     */
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return ['text', 'number', 'password'].includes(value);
      }
    },
    /**
     * Mínimo numero de letras (si es tipo text)
     */
    minLength: Number,
    /**
     * Maximo numero de letras (si es tipo text)
     */
    maxLength: Number,
    /**
     * Numero mínimo permitido (si es tipo number)
     */
    min: Number,
    /**
     * Numero máximo permitido (si es tipo number)
     */
    max: Number,
    /**
     * Modifica el estado deshabilitado del input
     */
    disabled: Boolean,
    /**
     * Modifica el estado solo lectura del input
     */
    readOnly: Boolean,
    /**
     * El texto predefinido cuando no hay contenido.
     */
    placeholder: {
      type: String,
      default: 'Escribir...'
    },
    /**
     * Define si el input es requerido
     */
    required: Boolean,
    /**
     * Define si el componente es invalido, si se especifica un string en vez de un "true", aparecera la razon debajo del input
     */
    invalid: {
      type: [String, Boolean],
      default: false
    },
    /**
     * Expresión regular contra la que se comprobaran los valores introducidos.
     * Se comprueba con RegExp.prototype.test (https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/RegExp/test)
     */
    pattern: RegExp,
    /**
     * Texto a mostrar cuando la expresión regular falle
     */
    patternReason: String,
    /**
     * Si se define un numero, el evento @input se emitira cuando el usuario deje de escribir N milisegundos.
     */
    debounce: Number,
    /**
     * Funcion para modificar/formatear el valor en tiempo real
     */
    mask: Function,
    /**
     * Establecer clases en elemento donde lanza los eventos para testing QA
     */
    dusk: {
      type: String,
      default: ''
    },
    /**
     * Establecer prop para permitir desactivar el autocompletado
     */
    autocomplete: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    focus: false,
    stored: '',
    debounceFn: {},
    invalidStored: false,
    invalidReasonStored: '',
    toggleType: 'password',
    version
  }),
  computed: {
    isInvalid() {
      return this.invalid !== false || this.invalidStored;
    },
    showInvalidReason() {
      const { isInvalid, patternReason, invalid, invalidReasonStored } = this;

      return (
        (isInvalid && invalid.length > 0) ||
        (isInvalid && patternReason !== undefined) ||
        (isInvalid && invalidReasonStored !== '')
      );
    },
    invalidReason() {
      const { invalid, isInvalid, patternReason, invalidReasonStored } = this;

      if (invalid !== false && typeof invalid === 'string' && invalidReasonStored === '') {
        return invalid;
      }

      if (isInvalid && invalidReasonStored !== '') {
        return invalidReasonStored;
      }

      return patternReason;
    }
  },
  watch: {
    value: 'syncStored',
    pattern: {
      handler(valor) {
        this.$nextTick(() => {
          if (valor !== undefined && valor !== '' && this.value.length > 0) {
            this.validateValue(this.value);
          }
        });
      }
    }
  },
  created() {
    const { debounce } = this;

    this.syncStored();
    if (debounce) this.debounceSetup();
  },
  methods: {
    checkInvalid() {
      const { isInvalid, required, invalidReason, stored, invalid, minLength, type } = this;
      this.invalidStored = false;
      this.invalidReasonStored = '';
      this.validateValue(this.value);
      let status = isInvalid;
      let reason = invalidReason;

      if (typeof invalid === 'string' || invalid === true) {
        this.invalidStored = true;
        return { status, reason };
      }

      if (
        required &&
        ((['text', 'password'].includes(type) && (!stored || stored.length === 0)) ||
          (type === 'number' && String(stored).length === 0))
      ) {
        this.invalidStored = true;
        status = true;
        reason = 'Este campo es requerido';
      }

      if (required && minLength !== undefined && stored.length < minLength) {
        this.invalidStored = true;
        this.invalidReasonStored = `Mínimo ${minLength} caracteres`;
        status = true;
        reason = `Mínimo ${minLength} caracteres`;
      }

      return { status, reason };
    },
    validateValue(value) {
      const { minLength, maxLength, min, max, type, $refs, pattern } = this;
      const { input } = $refs;
      let validated = value;

      // Resetear si antes era invalido por el pattern
      this.invalidStored = false;
      this.invalidReasonStored = '';

      // Comprobar si existe pattern
      if (validated.length > 0 && pattern && !pattern.test(validated)) {
        this.invalidStored = true;
      }

      if (validated.length > maxLength && type === 'text') {
        validated = validated.slice(0, maxLength);
        input.value = validated;
      }

      if ((validated.length === 0 || validated.length > minLength) && type === 'text') {
        this.invalidReasonStored = '';
      }

      if (type === 'number' && validated < min) {
        validated = min;
        input.value = validated;
      }

      if (type === 'number' && validated > max) {
        validated = max;
        input.value = validated;
      }

      return validated;
    },
    onInput(event) {
      const { debounce, mask, type } = this;
      let modified = event.target.value;

      if (type === 'number' && modified) modified = Number(modified);

      modified = this.validateValue(modified);

      if (mask) modified = mask(modified);

      this.stored = modified;

      const func = debounce ? this.debounceFn : this.emitInput;

      func(modified);
    },
    onEnter(event) {
      this.$emit('enter');
    },
    emitInput(value) {
      /**
       * @input event
       *
       * @event input
       * @property {string|number} value El valor introducido por el usuario
       */
      this.$emit('input', value);
    },
    setFocus(status, event) {
      if (!event.isTrusted) return;
      this.focus = status;
      if (status) {
        this.$emit('focus');
      }
      if (!status) {
        this.$emit('blur');
      }
    },
    checkArrowKeys(event) {
      if (event.keyCode === 9) {
        this.$emit('tabPress');
      }
      if (event.keyCode === 38) {
        this.$emit('arrowPress', 'up');
        event.preventDefault();
      }
      if (event.keyCode === 40) {
        this.$emit('arrowPress', 'down');
        event.preventDefault();
      }
    },
    onParentClick() {
      this.$refs.input.focus();
    },
    syncStored() {
      this.stored = this.value;
    },
    debounceSetup() {
      this.debounceFn = debounceHelper(this.emitInput, this.debounce);
    }
  }
};
